export const callTimelineFiltersActionType = {
  set: 'CONFERENCE_CALL/CALL_TIMELINE_FILTERS_SET',
  setDetail: 'CONFERENCE_CALL/CALL_TIMELINE_DETAIL_FILTERS_SET',
  clear: 'CONFERENCE_CALL/CALL_TIMELINE_FILTERS_CLEAR',
  clearDetail: 'CONFERENCE_CALL/CALL_TIMELINE_DETAIL_FILTERS_CLEAR',
}

export const setCallTimelineFilters = (key: any, value = undefined) => ({
  type: callTimelineFiltersActionType.set,
  payload: {
    key,
    value,
  },
})

export const setCallTimelineDetailFilters = (key: any, value: any) => ({
  type: callTimelineFiltersActionType.setDetail,
  payload: {
    key,
    value,
  },
})

export const clearCallTimelineFilters = () => ({
  type: callTimelineFiltersActionType.clear,
})

export const clearCallTimelineDetailFilters = () => ({
  type: callTimelineFiltersActionType.clearDetail,
})
